import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import Rule from './Rule';
import _ from 'lodash';

class Segment extends DomainObject {
  id;
  rules = [];

  _relations = {
    rules: [Rule]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      rules: observable,
      locationRule: computed,
      departmentRule: computed,
      employmentTypeRule: computed
    });

    this.merge(other);
  }

  get locationRule() {
    return _.find(this.rules, r => r.ruleType === 'location');
  }

  get departmentRule() {
    return _.find(this.rules, r => r.ruleType === 'department');
  }

  get employmentTypeRule() {
    return _.find(this.rules, r => r.ruleType === 'employment_type');
  }
}

export default Segment;
